var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.endPlaceholder')}},[_c('el-input',{attrs:{"type":"text"},model:{value:(_vm.optionModel.endPlaceholder),callback:function ($$v) {_vm.$set(_vm.optionModel, "endPlaceholder", $$v)},expression:"optionModel.endPlaceholder"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }